module.exports = __webpack_public_path__ + "static/media/Technologies.45faa5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Platformsicons/Technologies.png
// module id = 141
// module chunks = 0